import { render, staticRenderFns } from "./ReportInfo.vue?vue&type=template&id=07adf512"
import script from "./ReportInfo.vue?vue&type=script&lang=js"
export * from "./ReportInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07adf512')) {
      api.createRecord('07adf512', component.options)
    } else {
      api.reload('07adf512', component.options)
    }
    module.hot.accept("./ReportInfo.vue?vue&type=template&id=07adf512", function () {
      api.rerender('07adf512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ReportInfo.vue"
export default component.exports